/**
 * OwnYou Border Radius Tokens — Sprint 14 Production Design System
 *
 * @see docs/sprints/ownyou-sprint14-spec.md Package 1
 */
/**
 * Border radius scale
 */
export const radius = {
    sm: 6, // Subtle rounding (inputs, small badges)
    md: 8, // Standard (cards, buttons)
    lg: 12, // Prominent (modal, bottom sheet)
    xl: 16, // Large (feature cards)
    full: 9999, // Pill shape (avatar, tags)
};
/**
 * CSS custom property tokens for border radius
 */
export const radiusTokens = {
    '--radius-sm': `${radius.sm}px`,
    '--radius-md': `${radius.md}px`,
    '--radius-lg': `${radius.lg}px`,
    '--radius-xl': `${radius.xl}px`,
    '--radius-full': `${radius.full}px`,
};
//# sourceMappingURL=radius.js.map